export enum LiveFeedEventType {
  Goal = 'GOAL',
  GoalFromPenalty = 'GOAL_FROM_PENALTY',
  OwnGoal = 'OWN_GOAL',
  YellowCard = 'YELLOW_CARD',
  FirstYellowCard = 'FIRST_YELLOW_CARD',
  SecondYellowCard = 'SECOND_YELLOW_CARD',
  RedCard = 'RED_CARD',
  Substitution = 'SUBSTITUTION',
}

export type LiveFeedPerson = {
  id: string;
  name: string;
  teamId: string;
};

export type LiveFeedEvent = {
  competition: string;
  match: string;
  externalMatchId: string;
  minute: number;
  score: {
    home: number;
    away: number;
  };
  kickOffDate: string;
  kickOffTime: string;
  eventType: LiveFeedEventType;
  person: LiveFeedPerson;
  personOff?: LiveFeedPerson;
};

export type LiveFeed = {
  _id: string;
  events: LiveFeedEvent[];
};
